<template>
  <table class="guide-table">
    <thead>
      <tr>
        <th :colspan="columns.length" :class="title">
          <h1>{{ title }}</h1>
        </th>
      </tr>
      <tr>
        <th v-for="(item, index) in columns" :key="index">{{ item }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in rows" :key="index">
        <td v-for="(value, name, index) in row" :key="index">
          <span v-html="value"></span>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
</template>

<script>
export default {
  name: "NTFToolkitTable",
  props: {
    columns: Array,
    rows: Array,
    title: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
  width: 100%;
}
th {
  font-size: 20px;
  padding: 10px;
}

.guide-table {
  text-align: center;
}
tr:nth-child(even) {
  background-color: #eee;
}
tr:nth-child(odd) {
  background-color: #fafafa;
}

.Bowls {
  background-color: #5aaa5a;
  color: whitesmoke;
  padding: 15px;
}

.Breakfasts {
  background-color: #5381ec;
  color: whitesmoke;
  padding: 15px;
}

.Breads {
  background-color: #ee9c32;
  color: whitesmoke;
  padding: 15px;
}

.Pizzas {
  background-color: #e44e28;
  color: whitesmoke;
  padding: 15px;
}

.Pouches {
  background-color: #5aaa5a;
  color: whitesmoke;
  padding: 15px;
}

.Sandwiches {
  background-color: #5381ec;
  color: whitesmoke;
  padding: 15px;
}

.Trays {
  background-color: #ee9c32;
}

/* MOBILE */
@media screen and (max-width: 700px) {
  .table-container {
    overflow-x: auto;
  }

  .table-title {
    text-align: left;
  }
}
</style>
